import FormattedMessage from 'I18n/components/FormattedMessage';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import AssociatedExecutionStates from 'automation-ui-log-events/records/ExecutionResult/AssociatedExecutionStates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultsTabs = ({
  handleTabChange,
  tab
}) => {
  return /*#__PURE__*/_jsxs(UITabs, {
    selected: tab,
    onSelectedChange: ({
      target: {
        value
      }
    }) => handleTabChange(value),
    use: "enclosed",
    children: [/*#__PURE__*/_jsx(UITab, {
      className: "p-x-4",
      tabId: AssociatedExecutionStates.FAILURE,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-log-events.logEventExecutionResultsTable.failuresTab"
      })
    }), /*#__PURE__*/_jsx(UITab, {
      className: "p-x-4",
      tabId: AssociatedExecutionStates.SUCCESS,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-log-events.logEventExecutionResultsTable.successesTab"
      })
    })]
  });
};
export default ResultsTabs;